export const createLatestRequestGuard = () => {
    let latestSeq = 0;
    const never = () => new Promise(() => {});

    return {
        next: () => {
            latestSeq += 1;
            return latestSeq;
        },
        guard: (promise, seq) =>
            promise.then(
                result => (seq === latestSeq ? result : never()),
                error => (seq === latestSeq ? Promise.reject(error) : never())
            ),
    };
};
